import { Stack } from '@mui/material'

import { preview } from '@/components/form/preview'
import { PreviewTabs } from '../../../../components/shared/PreviewTabs'
import { OrderAvatar } from '../../../../components/OrderAvatar/'

import { TabValues } from '../../../../typings'
import { OrderFormValues } from '../typings'

const noop = () => undefined

type Props = {
  initialValues: OrderFormValues
  order: uui.domain.client.rm.ExtendedOrderStep | undefined
  tab: TabValues
  onClose: () => void
}

export function Header(props: Props) {
  const { initialValues, order, tab, onClose } = props

  const subtitle = order?.atDepot
    ? order.depot.name
    : order?.location.address || order?.location.geoAddress || ''

  return (
    <Stack paddingTop={2} paddingLeft={3} width="100%" spacing={2}>
      <preview.Header
        title={initialValues.order.name}
        subtitle={subtitle}
        testId="order-view-header"
        avatar={
          order ? (
            <OrderAvatar extendedOrderStep={order} style={{ marginRight: 16 }} size={42} />
          ) : null
        }
        onClose={onClose}
      >
        <PreviewTabs disabled tab={tab} setTab={noop} testIdPrefix="order-form-tab__" />
      </preview.Header>
    </Stack>
  )
}
